<template>
  <div>
    <div class="centered" v-if="videoList.length === 0">
      <div class="container" style="padding: 2rem">
        <h1 class="title">Please stand by</h1>
        <p>
          If nothing is happening there might be an issue with your browser or
          network. Wait at least a few seconds then press 'Try Again', or reload
          the page.
        </p>
        <p class="is-hidden-touch">
          Insure you are using an up to date version of Chrome or Microsoft
          Edge. Internet Explorer (Edge prior to version 79) is not compatable.
        </p>
        <br />
        <p class="is-hidden-touch">
          You can perform a diagnostics test using the
          <a href="https://test.webrtc.org/">WebRTC Troubleshooter</a> to check
          if your network is configured to accept streaming content.
        </p>
        <p>
          You can report the problem to our IT department using option from the
          cog menu.
        </p>
        <!-- <br />
        <button class="button is-info" onClick="window.location.reload(true)">
          <span class="is-size-6">Try Again</span>
        </button> -->
      </div>
    </div>
    <div v-else>
      <div v-for="item in videoList" v-bind:key="item.track.id" class="video-item">
        <video autoplay playsinline ref="videos" :id="item.track.id" :srcObject.prop="item.streams[0]"
          poster="/loader.svg"></video>
      </div>
      <div v-for="item in audioList" v-bind:key="item.track.id" class="audio-item">
        <audio autoplay playsinline ref="audio" :id="item.track.id" :srcObject.prop="item.streams[0]"></audio>
      </div>
    </div>
  </div>
</template>

<style scoped>
.video-list {
  height: auto;
}

.video-list div {
  padding: 0px;
}

.video-item {
  display: flex;
}

.popout {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 25%;
  margin: 2rem;
  z-index: 999;
}

@media all and (display-mode: fullscreen) {

  /* Centering for 4:3 displays */
  video {
    position: relative;
    top: 50%;
    /* transform: translateY(-50%); */
  }
}
</style>

<script>
import { store } from '@/socket'
import { bus } from '../common/bus'

import ScreenFull from 'screenfull'
import Bowser from 'bowser'
import log from 'loglevel'

const browser = Bowser.getParser(window.navigator.userAgent)

// require("adapterjs");
export default {
  name: 'Media',
  components: {},
  data() {
    return {
      connection: null,
      playing: false,
      videoList: [],
      audioList: []
    }
  },
  props: {
    autoplay: {
      type: Boolean,
      default: true
    }
  },
  destroyed() {
    log.info('Media destroyed')

    clearInterval(this.playButtonInterval)
    this.connection.close()
    this.connection = null
    store.unsubscribe('offer')
    bus.$off('play')
  },
  mounted() {
    log.info('Media mounted')

    var mountCtx = this

    store.state.useVP8 = localStorage.getItem('useVP8') == 'true'

    // Setup bus listeners
    bus.$on('play', this.play)

    // Fullscreen helper
    if (!browser.is('iOS')) {
      ScreenFull.on('change', () => {
        if (ScreenFull.isFullscreen) {
          document.body.scrollTop = 0 // For Safari
          document.documentElement.scrollTop = 0
        }
      })
    }

    let reloadTimer
    let sdpTimer

    log.info('Media init RTCPeerConnection')
    this.connection = new RTCPeerConnection({
      iceServers: [
        {
          urls: [
            'stun:stun.cloudflare.com:3478',
            'stun:stun.l.google.com:19302'
          ],
          username: 'client',
          credential: 'notasecret'
        },
        {
          "username": "janus",
          "credential": "lEydLHNMUOEwpALpQ3oCI7dgXFgksSdJSHDwBGZ9vOE=",
          "urls": [
            "turn:my.biddingmate.com.au:3478"
          ]
        }
      ],
      iceTransportPolicy: 'all'
    })

    store.subscribe('offer', function (payload) {
      log.info('Have offer')
      mountCtx.connection.setRemoteDescription(payload.sdp)
      mountCtx.connection.createAnswer().then(function (answer) {
        log.info('Created answer')
        mountCtx.connection.setLocalDescription(answer)
      })
    })

    function answer(connection) {
      let payload = {
        action: 'answer',
        buyer: store.state.selectedBuyer,
        token: sessionStorage.getItem('id_token'),
        sdp: connection.currentLocalDescription
      }

      log.info('Have answer')

      store.state.ws.send(JSON.stringify(payload))
    }

    this.connection.onsignalingstatechange = () =>
      log.info('Media signal state: ' + this.connection.signalingState)
    this.connection.oniceconnectionstatechange = () => {
      log.info('Media ICE state: ' + this.connection.iceConnectionState)
      if (this.connection.iceConnectionState == 'failed') {
        mountCtx.videoList = []
        log.error('Media link is down.')
        close()
      }
      if (this.connection.iceConnectionState == 'disconnected') {
        log.error(
          'Media link gone, will reload in 3 seconds unless it is restored'
        )
        mountCtx.videoList = []
        // reloadTimer = setTimeout(function() {
        //   window.location.reload(false)
        // }, 3000)
      }
      if (this.connection.iceConnectionState == 'connected') {
        clearTimeout(reloadTimer)
      }
    }

    let iceTimeout = false
    this.connection.onicecandidate = event => {
      log.debug(event.candidate)
      if (
        event.candidate !== null &&
        event.candidate.address.includes('.local')
      ) {
        log.warn('Invalid mDNS candidate')
      }
      if (event.candidate === null) {
        clearTimeout(sdpTimer)
        if (iceTimeout == false) {
          log.info('ICE complete, sending answer')
          answer(mountCtx.connection)
        }
      } else {
        clearTimeout(sdpTimer)
        sdpTimer = setTimeout(function () {
          iceTimeout = true
          log.warn('ICE timeout, sending answer anyway')
          answer(mountCtx.connection)
        }, 10000)
      }
    }

    this.connection.ontrack = event => {
      log.info('Media has ' + event.track.kind)

      if (event.track.kind == 'video') {
        mountCtx.videoList.push(event)

        mountCtx.playButtonInterval = setInterval(function () {
          let media = mountCtx.$refs.videos[0]
          if (media.paused) {
            bus.$emit('playing', false)
          } else {
            bus.$emit('playing', true)
          }
        }, 2000)
      } else {
        mountCtx.audioList.push(event)
      }
    }

    mountCtx.connect()
  },
  methods: {
    setup() { },
    connect() {
      // Setup our media offer
      let send = function () {
        if (store.state.isDead) {
          log.error('Websocket is closed, giving up')
          return
        }
        // Check if socket is alive yet
        if (!store.state.isConnected) {
          log.warn('Websocket not open, retrying in 1s')
          setTimeout(send, 1000)
          return
        }

        // Check out browser to see if we need VP8
        // var useVP8 = false
        if (browser.is('Safari') || browser.is('iOS')) {
          log.warn('No VP9 support on apple, will use compatibility stream')
          store.state.useVP8 = true
        }

        let payload = {
          action: 'connect',
          buyer: store.state.selectedBuyer,
          token: sessionStorage.getItem('id_token'),

          apple: store.state.useVP8
        }

        store.state.ws.send(JSON.stringify(payload))
      }
      log.info('Exchange SDP')
      send()
    },
    play() {
      let audio = this.$refs.audio[0]
      let video = this.$refs.videos[0]
      if (video.paused) {
        video.play()
        audio.muted = false
        bus.$emit('playing', true)
      } else {
        video.pause()
        audio.muted = true
        bus.$emit('playing', false)
      }
    }
  }
}
</script>
